module.exports = __webpack_public_path__ + "static/media/Rectangle 91.66c126ab.png";